import { styled } from '@mui/material/styles';
import Print from 'global/components/print';

export const TableHeaderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: theme.spacing(4),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(1),
}));

export const NotifyTopHeader = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  padding: `5px 0px 5px 50px`,
}));

export const TableRowWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  color: theme.palette.text.primary,
  fontSize: '0.75rem',
  fontWeight: 500,
  alignItems: 'center',
}));

export const StyledPrint = styled(Print)({
  position: 'absolute',
  top: `72px !important`,
});

export const PadLeft = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));
